module.exports = "/assets/926cb046494b1348e9ab550442882d30.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/RB.png
// module id = 1781
// module chunks = 0